export default __webpack_public_path__ + "static/media/bay_lynx.5c9fe659.png";